// File: @/components/analytics/tracked-button.tsx

'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX, MouseEvent, ReactNode } from 'react';
import { ctaClickEvent, track } from '@/lib/analytics';
interface TrackedButtonProps {
  readonly children: ReactNode;
  readonly elementId: string;
  readonly placement: string;
  readonly elementText?: string;
  readonly type?: 'button' | 'submit' | 'reset';
  readonly ariaLabel?: string;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly onClick?: () => void;
}
function getResolvedElementText(elementText: string | undefined, children: ReactNode): string {
  if (elementText !== undefined) {
    return elementText;
  }
  if (typeof children === 'string') {
    return children;
  }
  return '';
}
export function TrackedButton(t0) {
  const $ = _c(13);
  const {
    children,
    elementId,
    placement,
    elementText,
    type: t1,
    ariaLabel,
    className,
    disabled,
    onClick
  } = t0;
  const type = t1 === undefined ? "button" : t1;
  let t2;
  if ($[0] !== children || $[1] !== elementId || $[2] !== elementText || $[3] !== onClick || $[4] !== placement) {
    t2 = _event => {
      track(ctaClickEvent(elementId, getResolvedElementText(elementText, children), placement));
      if (onClick !== undefined) {
        onClick();
      }
    };
    $[0] = children;
    $[1] = elementId;
    $[2] = elementText;
    $[3] = onClick;
    $[4] = placement;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleClick = t2;
  let t3;
  if ($[6] !== ariaLabel || $[7] !== children || $[8] !== className || $[9] !== disabled || $[10] !== handleClick || $[11] !== type) {
    t3 = <button aria-label={ariaLabel} className={className} disabled={disabled} type={type} onClick={handleClick}>{children}</button>;
    $[6] = ariaLabel;
    $[7] = children;
    $[8] = className;
    $[9] = disabled;
    $[10] = handleClick;
    $[11] = type;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}